import * as React from 'react';

export class Paper extends React.Component<Props, {}> {

    public constructor(props: Props) {
        super(props);
    }

    public render() {
        return (
            <div style={{width: '100%', padding: '32px', marginBottom: "48px", backgroundColor: '#fff', boxShadow: '1px 1px 16px rgba(0,0,0,0.5)'}}>
                {this.props.title != null && (
                    <div style={{fontSize: '20px', fontWeight: 900, color: '#333', paddingBottom: '32px'}}>
                        {this.props.title}
                    </div>
                )}
                {this.props.desc != null && (
                    <div style={{fontSize: '16px', fontWeight: 300, color: '#888', paddingBottom: '32px', textAlign: 'center'}}>
                        {this.props.desc}
                    </div>
                )}
                {this.props.children}
            </div>
        );
    }

}

export interface Props {

    title?: string;
    desc?: string;

}